import Meta from '@/components/common/Meta'

import ShipToSchoolPage from '@/v2/components/pages/landing-pages/ship-to-school-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/ship-to-school-page'

interface ShipToSchoolPageProps {}

const Page: React.FC<ShipToSchoolPageProps> = () => {
  return (
    <>
      <Meta
        title={LANDING_PAGES_META_CONTENTS.ship_to_school.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''}
        keywords={
          LANDING_PAGES_META_CONTENTS.ship_to_school?.keywords ?? LANDING_PAGES_META_CONTENTS.default?.keywords ?? ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.ship_to_school?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <ShipToSchoolPage />
    </>
  )
}

export default Page
